import React from 'react';

export default function ItemImages({ domElementsRef, preview }) {
  return (
    <div ref={(ref) => (domElementsRef.current.img = ref)} className={'my-gift__filter-image'}>
      {preview?.map((src, i) => (
        <img key={i} src={src} />
      ))}
    </div>
  );
}
